module.exports = __webpack_public_path__ + "static/media/Withdrawal.ce6ecadd.svg";